import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router);

//解决vue-router在3.0以上版本重复跳转相同路由报错问题
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
  },
  {
      path: '/',
      component: resolve => require(['../base/Home.vue'], resolve),
      meta: { title: '智OA后台管理系统' },
      children:[
        {
            path: '/home',
            component: resolve => require(['../components/MainHome.vue'], resolve),
            meta: { title: '首页', target:'home' },
            name:'home'
        },
        
        {
          path: '/home/noticelist',
          component: resolve => require(['../components/home/noticeList.vue'], resolve),
          meta: { title: '公告列表', target:'homeNotice' },
          name:'noticelist'
        },
        {
          path: '/home/messagelist',
          component: resolve => require(['../components/home/messageList.vue'], resolve),
          meta: { title: '信息中心', target:'homeMessage'},
          name:'messagelist'
        },
        {
          path: '/account/info',
          component: resolve => require(['../components/account/info.vue'], resolve),
          meta: { title: '个人信息', target:'account' },
          name:'info'
        },
        {
          path: '/account/companyMessage',
          component: resolve => require(['../components/account/companyMessage.vue'], resolve),
          meta: { title: '企业信息', target:'account' },
          name:'companyMessage'
        },
        {
          path: '/account/password',
          component: resolve => require(['../components/account/password.vue'], resolve),
          meta: { title: '账号密码', target:'account' },
          name:'password',
        },
        {
          path: '/account/setPsd',
          component: resolve => require(['../components/account/setPsd.vue'], resolve),
          meta: { title: '编辑密码', target:'account' },
          name:'setPsd'
        },
        {
          path: '/account/setMobile',
          component: resolve => require(['../components/account/setMobile.vue'], resolve),
          meta: { title: '编辑账号', target:'account' },
          name:'setMobile'
        },
        {
          path: '/system/notice',
          component: resolve => require(['../components/system/notice.vue'], resolve),
          meta: { title: '公告管理', target:'system',keepAlive:true },
          name:'notice'
        },
        {
          path: '/system/slider',
          component: resolve => require(['../components/system/slider.vue'], resolve),
          meta: { title: '轮播管理', target:'system',keepAlive:true },
          name:'slider'
        },
        {
          path: '/system/logo',
          component: resolve => require(['../components/system/logo.vue'], resolve),
          meta: { title: 'logo管理', target:'system'},
          name:'logo'
        },

        //人事管理
        {
          path: '/personnel/user',
          component: resolve => require(['../components/personnel/user/user.vue'], resolve),
          meta: { title: '员工管理', target:'personnel',keepAlive:true },
          name:'user'
        },
        {
          path: '/personnel/userEdit',
          component: resolve => require(['../components/personnel/user/userEdit.vue'], resolve),
          meta: { title: '员工编辑', target:'personnel',keepAlive:true},
          name:'userEdit'
        },
        {
          path: '/personnel/userDetail',
          component: resolve => require(['../components/personnel/user/userDetail.vue'], resolve),
          meta: { title: '员工详情', target:'personnel',keepAlive:true  },
          name:'userDetail'
        },
        // {
        //   path: '/personnel/organization/limit',
        //   component: resolve => require(['../components/personnel/organization/limit.vue'], resolve),
        //   meta: { title: '权限管理', target:'personnel'  }
        // },
        {
          path: '/personnel/organization/department',
          component: resolve => require(['../components/personnel/organization/department.vue'], resolve),
          meta: { title: '部门管理', target:'personnel',keepAlive:true },
          name:'department'
        },
        {
          path: '/personnel/organization/position',
          component: resolve => require(['../components/personnel/organization/position.vue'], resolve),
          meta: { title: '岗位管理', target:'personnel',keepAlive:true },
          name:'position'
        },
        {
          path: '/personnel/recruit/rercuitPostion',
          component: resolve => require(['../components/personnel/recruit/recruitPosition.vue'], resolve),
          meta: { title: '招聘职位', target:'personnel',keepAlive:true },
          name:'recruitPosition'
        },
        {
          path: '/personnel/recruit/recruitStat',
          component: resolve => require(['../components/personnel/recruit/recruitStat.vue'], resolve),
          meta: { title: '招聘统计', target:'personnel',keepAlive:true },
          name:'recruitStat'
        },
        {
          path: '/personnel/recruit/recruitCheck',
          component: resolve => require(['../components/personnel/recruit/recruitCheck.vue'], resolve),
          meta: { title: '人员登记', target:'personnel',keepAlive:true },
          name:'recruitCheck'
        },
        {
          path: '/personnel/entry',
          component: resolve => require(['../components/personnel/userRelation/entry/entry.vue'], resolve),
          meta: { title: '入职管理', target:'personnel',keepAlive:true },
          name:'entry'
        },
        {
          path: '/personnel/recruit/recruitSchedule',
          component: resolve => require(['../components/personnel/recruit/recruitSchedule.vue'], resolve),
          meta: { title: '面试日程', target:'personnel',keepAlive:true },
          name:'recruitSchedule'
        },
        {
          path: '/personnel/confirmEntry',
          component: resolve => require(['../components/personnel/userRelation/entry/confirmEntry.vue'], resolve),
          meta: { title: '确认入职', target:'personnel'  },
          name:'confirmEntry'
        },
        {
          path: '/personnel/official',
          component: resolve => require(['../components/personnel/userRelation/official/official.vue'], resolve),
          meta: { title: '转正管理', target:'personnel',keepAlive:true },
          name:'official'
        },
        {
          path: '/personnel/remove',
          component: resolve => require(['../components/personnel/userRelation/remove/remove.vue'], resolve),
          meta: { title: '调动管理', target:'personnel',keepAlive:true },
          name:'remove'
        },
        {
          path: '/personnel/leave',
          component: resolve => require(['../components/personnel/userRelation/leave/leave.vue'], resolve),
          meta: { title: '离职管理', target:'personnel',keepAlive:true },
          name:'leave'
        },
        //考勤管理
        {
          path: '/checking_in/set',
          component: resolve => require(['../components/checking_in/set/set.vue'], resolve),
          meta: { title: '考勤设置', target:'checking_in',keepAlive:true, saveFlag:true },
          name:'checkingInSet'
        },
        {
          path:'/checking_in/set/checkInGroup',
          component: resolve => require(['../components/checking_in/set/checkInGroup.vue'], resolve),
          meta: {title:'设置/新增', target:'checking_in',keepAlive:true},          
          name:'checkInGroup'
        },
        
        {
          path:'/checking_in/set/classes',
          component: resolve => require(['../components/checking_in/set/classesRedact.vue'], resolve),
          meta: {title:'班次设置', target:'checking_in',keepAlive:true},
          name:'classesRedact'
        },
        {
          path: '/checking_in/myself',
          component: resolve => require(['../components/checking_in/myself/myself.vue'], resolve),
          meta: { title: '我的考勤', target:'checking_in',keepAlive:true, saveFlag:true },
          name:'myself'
        },
        
        {
          path: '/checking_in/daily',
          component: resolve => require(['../components/checking_in/daily/daily.vue'], resolve),
          meta: { title: '考勤日报', target:'checking_in',keepAlive:true, saveFlag:true },
          name:'daily'
        },
        {
          path: '/checking_in/daily/dailyDetail/:id',
          component: resolve => require(['../components/checking_in/daily/dailyDetail.vue'], resolve),
          meta: { title: '日报详情', target:'checking_in',keepAlive:true },
          name:'dailyDetail'
        },

        // {
        //   path: '/checking_in/daily/dailyDetail/PersonDetail/:id',
        //   component: resolve => require(['../components/checking_in/daily/dailyDetail.vue'], resolve),
        //   meta: { title: '员工日报详情' },
        //   name:'persnDetail'
        // },
        {
          path: '/checking_in/monthly',
          component: resolve => require(['../components/checking_in/monthly/monthly.vue'], resolve),
          meta: { title: '考勤月报', target:'checking_in',keepAlive:true },
          name:'monthly'
        },
        {
          path: '/checking_in/monthly/MonthlyDetail/:userId',
          component: resolve => require(['../components/checking_in/monthly/detail.vue'], resolve),
          meta: { title: '月报详情', target:'checking_in',keepAlive:true },
          name:'MonthlyDetail'
        },
        {
          path: '/checking_in/checkingInLog/log',
          component: resolve => require(['../components/checking_in/checkingInLog/checkingInLog.vue'], resolve),
          meta: { title: '打卡记录', target:'checking_in',keepAlive:true  },
          name:'checkingInLog'
        },
        {
          path: '/checking_in/vacationLog/log',
          component: resolve => require(['../components/checking_in/checkingInLog/vacationLog.vue'], resolve),
          meta: { title: '年假加班记录', target:'checking_in',keepAlive:true  },
          name:'vacationLog'
        },
        //绩效管理
        {
          path: '/perf/perfMain/perf',
          component: resolve => require(['../components/perf/perfMain/perf.vue'], resolve),
          meta: { title: '绩效管理', target:'perf',keepAlive:true  },
          name:'perf'
        },
        {
          path: '/perf/perfMain/personPerf/:id',
          component: resolve => require(['../components/perf/perfMain/personPerf.vue'], resolve),
          meta: { title: '考核记录', target:'perf',keepAlive:true },
          name:'personPerf'
        },
        {
          path: '/perf/perfMain/personDetail/:id',
          component: resolve => require(['../components/perf/perfMain/personDetail.vue'], resolve),
          meta: { title: '考核详情', target:'perf',keepAlive:false },
          name:'personDetail'
        },
        {
          path: '/perf/model/modelList',
          component: resolve => require(['../components/perf/model/model.vue'], resolve),
          meta: { title: '考核模版', target:'perf',keepAlive:true },
          name:'modelList'
        },
        {
          path: '/perf/model/plus',
          component: resolve => require(['../components/perf/model/plus.vue'], resolve),
          meta: { title: '新增/编辑/复制', target:'perf',keepAlive:false },
          name:'modePlus'
        },
        {
          path: '/perf/model/viewModel',
          component: resolve => require(['../components/perf/model/viewModel.vue'], resolve),
          meta: { title: '查看考核模版', target:'perf',keepAlive:false },
          name:'viewModel'
        },
        {
          path: '/perf/myAssess/myAssessList',
          component: resolve => require(['../components/perf/myAssess/myAssess.vue'], resolve),
          meta: { title: '我的考核', target:'perf',keepAlive:true },
          name:'myAssess'
        },
        
        {
          path: '/perf/mark/markList',
          component: resolve => require(['../components/perf/mark/mark.vue'], resolve),
          meta: { title: '绩效打分', target:'perf',keepAlive:true },
          name:'mark'
        },
        {
          path: '/perf/mark/markEdit/:id',
          component: resolve => require(['../components/perf/mark/markEdit.vue'], resolve),
          meta: { title: '评定打分', target:'perf',keepAlive:false },
          name:'markEdit'
        },
        {
          path: '/perf/decidePay/decidePayList',
          component: resolve => require(['../components/perf/decidePay/decidePay.vue'], resolve),
          meta: { title: '员工定薪', target:'perf',keepAlive:true },
          name:'decidePay'
        },
        {
          path: '/perf/history/historyList',
          component: resolve => require(['../components/perf/history/history.vue'], resolve),
          meta: { title: '历史薪资', target:'perf',keepAlive:true },
          name:'history'
        },
        {
          path: '/perf/history/detail/:id',
          component: resolve => require(['../components/perf/history/detail.vue'], resolve),
          meta: { title: '历史薪资详细', target:'perf',keepAlive:true },
          name:'historyDetail'
        },
        {
          path: '/perf/order/orderList',
          component: resolve => require(['../components/perf/order/myOrder.vue'], resolve),
          meta: { title: '我的工资单', target:'perf',keepAlive:true},
          name:'myOrder'
        },
        
        {
          path: '/perf/decidePay/plus/:id',
          component: resolve => require(['../components/perf/decidePay/plus.vue'], resolve),
          meta: { title: '新增/编辑', target:'perf',keepAlive:false },
          name:'payPlus'
        },

        //日志
        {
          path: '/log/logList',
          component: resolve => require(['../components/log/logList/index.vue'], resolve),
          meta: { title: '日志记录', target:'log',keepAlive:true },
          name:'logList_index'
        },
        {
          path: '/log/sendLog',
          component: resolve => require(['../components/log/sendLog/index.vue'], resolve),
          meta: { title: '我发起的', target:'log',keepAlive:true },
          name:'sendLog_index'
        },
        {
          path: '/log/receiveLog',
          component: resolve => require(['../components/log/receiveLog/index.vue'], resolve),
          meta: { title: '我收到的', target:'log',keepAlive:true },
          name:'receiveLog_index'
        },
        //项目
        {
          path: '/project/myProject',
          component: resolve => require(['../components/project/myProject/index.vue'], resolve),
          meta: { title: '我的项目', target:'project',keepAlive:true },
          name:'myProject_index'
        },
        {
          path: '/project/myProject/set',
          component: resolve => require(['../components/project/myProject/set/index.vue'], resolve),
          meta: { title: '项目设置', target:'project',keepAlive:true },
          name:'myProject_set_index'
        },
        {
          path: '/project/myProject/superAdmin',
          component: resolve => require(['../components/project/myProject/superAdmin.vue'], resolve),
          meta: { title: '项目超级管理员', target:'project',keepAlive:false },
          name:'superAdmin'
        },
        {
          path: '/project/myProject/projectDetail',
          component: resolve => require(['../components/project/myProject/projectDetail.vue'], resolve),
          meta: { title: '项目详情', target:'project',keepAlive:false },
          name:'projectDetail'
        },
        {
          path: '/project/myProject/taskDetail',
          component: resolve => require(['../components/project/myProject/taskDetail.vue'], resolve),
          meta: { title: '任务详情', target:'project',keepAlive:false },
          name:'taskDetail'
        },
        {
          path: '/project/projectPreview',
          component: resolve => require(['../components/project/projectPreview/index.vue'], resolve),
          meta: { title: '项目概览', target:'project',keepAlive:true },
          name:'projectPreview_index'
        },
        {
          path: '/project/projectPreview/userTask',
          component: resolve => require(['../components/project/projectPreview/userTask.vue'], resolve),
          meta: { title: '员工任务', target:'project',keepAlive:false },
          name:'userTask'
        },
        {
          path: '/project/myTask',
          component: resolve => require(['../components/project/myTask/index.vue'], resolve),
          meta: { title: '我的任务', target:'project',keepAlive:true },
          name:'myTask_index'
        },
        //审批
        {
          path: '/approve/set',
          component: resolve => require(['../components/approve/set/index.vue'], resolve),
          meta: { title: '审批设置', target:'approve',keepAlive:true },
          name:'approve_set_index'
        },
        {
          path: '/approve/set/edit',
          component: resolve => require(['../components/approve/set/approveEdit.vue'], resolve),
          meta: { title: '审批编辑', target:'approve',keepAlive:false },
          name:'approveEdit'
        },
        {
          path: '/approve/set/add',
          component: resolve => require(['../components/approve/set/approveAdd.vue'], resolve),
          meta: { title: '审批添加', target:'approve',keepAlive:false },
          name:'approveAdd'
        },
        {
          path: '/approve/log',
          component: resolve => require(['../components/approve/approveLog.vue'], resolve),
          meta: { title: '审批记录', target:'approve',keepAlive:true },
          name:'approveLog'
        },
        {
          path: '/approve/send',
          component: resolve => require(['../components/approve/sendApprove.vue'], resolve),
          meta: { title: '我发起的审批', target:'approve',keepAlive:true },
          name:'sendApprove'
        },
        {
          path: '/approve/check',
          component: resolve => require(['../components/approve/checkApprove.vue'], resolve),
          meta: { title: '待我审批', target:'approve',keepAlive:true },
          name:'checkApprove'
        },





        {
          path: '/404',
          component: resolve => require(['../components/404.vue'], resolve),
          meta: { title: '404' },
          name:'404'
      },
      ]
    },
    {
        path: '/login',
        component: resolve => require(['../components/Login.vue'], resolve),
        meta: { title: '登录' },
        name:'login'
    },
    {
        path: '*',
        redirect: '/404'
    },
    // {
    //   path: '/homeWork',
    //   component: resolve => require(['../base/HomeWork.vue'], resolve),
    //   meta: { title: '首页' },
    //   name:'home'
    // },
  ]
})
// 解决Loading chunk (\d)+ failed问题


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js